module.exports = __webpack_public_path__ + "img/google-play-badge-nb.32c140ad.png";